// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectPersonnelClaimsEmployeeDetail  {
    _originalTypeClassName = "Loom.BO.ProjectPersonnelClaimsEmployeeDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectPersonnelClaimsEmployeeDetail.translate = translateService;
}
this.Id = null;
this.PersonHours = null;
this.PersonMonths = null;
this.Cost = null;
this.WPs = null;
this.TimesheetMonth = null;
this.TimesheetMonthRaw = null;
this.TimesheetId = null;
this.TimesheetEntryId = null;
this.Employee = null;
this.DailyRateForPeriod = null;
this.DayEquivalents = null;
this.HourlyRateForPeriod = null;
this.DayEquivalentHours = null;
this.TotalPeriodCosts = null;
this.ActualWorkedHoursInMonth = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
PersonHours:any;
PersonMonths:any;
Cost:any;
WPs:any;
TimesheetMonth:any;
TimesheetMonthRaw:any;
TimesheetId:any;
TimesheetEntryId:any;
Employee:any;
DailyRateForPeriod:any;
DayEquivalents:any;
HourlyRateForPeriod:any;
DayEquivalentHours:any;
TotalPeriodCosts:any;
ActualWorkedHoursInMonth:any;
ProjectPersonnelClaimsReportMonthDetail:any;
EmploymentType:any;
EmployeeProjectSummary:any;
static setProjectPersonnelClaimsReportMonthDetail = ($this, value) => {
var oldValue = $this.ProjectPersonnelClaimsReportMonthDetail;
$this.ProjectPersonnelClaimsReportMonthDetail = value;
if (value != null) {
if (oldValue != null) {
Domain.ProjectPersonnelClaimsReportMonthDetail.removeProjectPersonnelClaimsEmployeeDetails(oldValue, $this);
}
Domain.ProjectPersonnelClaimsReportMonthDetail.addProjectPersonnelClaimsEmployeeDetails(value, $this);
}
}
static setEmploymentType = ($this, value) => {
var oldValue = $this.EmploymentType;
$this.EmploymentType = value;
if (value != null) {
}
}
static setEmployeeProjectSummary = ($this, value) => {
var oldValue = $this.EmployeeProjectSummary;
$this.EmployeeProjectSummary = value;
if (value != null) {
if (oldValue != null) {
Domain.ProjectPersonnelClaimsEmployeeSummary.removeEmployeeDetails(oldValue, $this);
}
Domain.ProjectPersonnelClaimsEmployeeSummary.addEmployeeDetails(value, $this);
}
}

static GetPersonMonths($this: any): any{return Joove.Common.safeNumber($this?.PersonHours) / Joove.Common.safeNumber(173);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}